// Telemetry never needs query strings, fragments, credentials or URL userinfo.
export const telemetryPath = (value: string): string => {
    try {
        const url = new URL(value, "https://collectohub.invalid");
        return url.pathname;
    } catch { return "/"; }
};

export const telemetryReferrer = (value: string): string => {
    if (!value) return "";
    try { return new URL(value).origin; } catch { return ""; }
};

const sensitiveKey = /email|password|token|secret|authorization|cookie|username|displayname|surname|phone|^name$|^code$/i;
const urlKey = /url|uri|path|page_location|landingpage/i;

export const sanitizeTelemetry = (params?: Record<string, unknown>): Record<string, unknown> | undefined => {
    if (!params) return undefined;
    const clean: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(params)) {
        if (sensitiveKey.test(key)) continue;
        if (typeof value === "string") {
            if (/referrer/i.test(key)) clean[key] = telemetryReferrer(value);
            else if (urlKey.test(key)) clean[key] = telemetryPath(value);
            else if (!value.includes("@") && !/[?#]|bearer\s/i.test(value)) clean[key] = value.slice(0, 200);
        } else if (typeof value === "number" || typeof value === "boolean") clean[key] = value;
        // Arbitrary nested objects must not bypass the sensitive-key filter.
    }
    return clean;
};
